module.exports = __webpack_public_path__ + "media/cancer.fbd06182.wav";